class SelfManagementPlatformPermissions {
    constructor({ enabled = false, update = false } = {}) {
        this.enabled = enabled
        this.update = update
    }
}

export default SelfManagementPlatformPermissions
